import React from 'react';
import CustomerSelection from '../components/customers/CustomerSelection';
import Alert from '../components/ui/Alert';

const CustomersPage: React.FC = () => {
    return (
        <div className="container">
            <div className="header">
                <h1>🏢 Select Organisation</h1>
                <p>Choose the organisation to continue</p>
            </div>

            <div className="form-container">
                <Alert />
                <CustomerSelection />
            </div>
        </div>
    );
};

export default CustomersPage;